export default "__VITE_ASSET__c25d63c1__"